import {Component, ElementRef} from '@angular/core';
import {kanUsersService} from "../../services/users";
import {kanDogsService} from "../../services/dogs";
import {Contract} from "../../../../classes/contract";
import {kanTermsService} from "../../services/terms";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
    selector: 'kan-contract',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanContract {

    public contract: any;
    public body: SafeHtml = '';
    public user: any = {};
    public dog: any = {};
    public terms: any[] = [];

    constructor(private element: ElementRef,
                private sanitizer: DomSanitizer,
                private termsService: kanTermsService,
                private usersService: kanUsersService,
                private dogsService: kanDogsService) {
    }

    ngOnInit(): void {
    }

    public setData(contract: any, userId: string, dogId: string) {
        let promises = [];
        this.contract = contract;
        this.body = this.sanitizer.bypassSecurityTrustHtml(this.contract.body);

        promises.push(this.termsService.getTerms());

        if(userId) {
            promises.push(this.usersService.getUserById(userId))
        }

        if(dogId) {
            promises.push(this.dogsService.getDog(dogId))
        }

        Promise.all(promises)
            .then((data) => {
                this.terms = data[0].filter((term) => {
                    return contract.terms.indexOf(term.id) > -1;
                });
                this.user = data[1];
                this.dog = data[2];
            });
    }

    public close() {
        this.element.nativeElement.remove();
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/components/contract/component.ts